import { render } from "./HoverWindow.vue?vue&type=template&id=3b921e1e"
import script from "./HoverWindow.vue?vue&type=script&lang=js"
export * from "./HoverWindow.vue?vue&type=script&lang=js"

import "./HoverWindow.vue?vue&type=style&index=0&id=3b921e1e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__